module.exports = __webpack_public_path__ + "img/question20.104a1213.png";